import colors from './colors';

const palette = {
  auth: {
    authStepButtons: {
      bg: colors.primary.main,
      outlineBorder: colors.gray[400],
      solidIcon: colors.white
    },
    layout: {
      formBg: colors.white,
      boxShadow: colors.blackOpacity[10],
      afterBg: colors.gray[100]
    },
    login: {
      iconBg: colors.primary[200],
      iconColor: colors.gray[600],
      text: {
        primary: colors.gray[600],
        secondary: colors.primary[200],
        error: colors.red[300]
      },
      inputBg: colors.primary[100],
      buttonIcon: colors.white,
      redirectedMessageColor: colors.gray[800],
      redirectedMessageBg: colors.secondary[175]
    },
    guestCheckout: {
      title: colors.gray[600],
      description: colors.gray[600],
      iconBg: colors.primary[200],
      iconColor: colors.gray[600],
      buttonBg: colors.primary.main,
      buttonColor: colors.white
    },
    existingAccount: {
      iconBg: colors.primary[200],
      iconColor: colors.gray[600],
      text: {
        primary: colors.gray[600],
        secondary: colors.gray[600],
        error: colors.red[300]
      },
      inputBg: colors.primary[100],
      buttonGuest: colors.secondary[800],
      buttonColor: colors.white,
      redirectedMessageColor: colors.gray[800],
      divider: colors.secondary[175]
    },
    reset: {
      contactsStep: {
        text: {
          primary: colors.gray[600],
          secondary: colors.white,
          error: colors.red[300]
        },
        button: {
          outlineBorder: colors.gray[400],
          outlineText: colors.gray[600]
        }
      },
      confirmationCodeStep: {
        text: {
          primary: colors.gray[600],
          secondary: colors.white,
          error: colors.red[300],
          link: colors.secondary[500]
        },
        btnIcon: colors.white,
        input: {
          activeBorder: colors.gray[200],
          background: colors.primary[100],
          placeholder: colors.gray[300]
        },
        codeResendColor: colors.gray[600],
        codeResendColorLink: colors.blue[300]
      },
      congratulationStep: {
        title: colors.gray[600],
        description: colors.gray[600],
        divider: colors.primary.main
      },
      restorePasswordStep: {
        text: {
          primary: colors.gray[600],
          secondary: colors.white,
          error: colors.red[300]
        },
        input: {
          iconBg: colors.primary[200],
          iconColor: colors.gray[600]
        },
        button: {
          outlineBorder: colors.gray[400],
          outlineText: colors.gray[600]
        }
      }
    },
    createAccount: {
      accountForm: {
        text: {
          primary: colors.gray[600],
          secondary: colors.white,
          error: colors.red[300]
        },
        iconColor: colors.gray[600],
        iconBg: colors.primary[200],
        dropdownBg: colors.primary[100],
        dropdownText: colors.black,
        placeholder: colors.gray[600],
        optionBorder: colors.gray[200]
      },
      referalCodeError: {
        codeColor: colors.red[500],
        bg: colors.red[100],
        subTitle: colors.gray[300],
        fieldIcon: colors.red[500],
        fieldBg: colors.white,
        iconColor: colors.white,
        buttonBg: colors.white,
        activeBttonBg: colors.red[500],
        buttonBgHover: colors.red[100],
        activeButtonHover: colors.red[700],
        buttonBorder: colors.red[500],
        buttonColor: colors.red[500],
        activeButtonColor: colors.white
      },
      confirmationPassword: {
        text: {
          primary: colors.gray[600],
          secondary: colors.white,
          error: colors.red[300]
        }
      }
    }
  },
  notFound: {
    title: colors.gray[600],
    description: colors.gray[300],
    buttonTitle: colors.gray[600],
    buttonLabel: colors.gray[300]
  },
  welcomePage: {
    bg: colors.primary[200],
    header: colors.gray[600],
    outlineBorder: colors.gray[600],
    outlineBg: colors.white
  },
  shop: {
    heading: colors.gray[550],
    description: colors.gray[300],
    subtitle: colors.gray[300],
    divider: colors.primary.main,
    icon: colors.primary.main,
    item: {
      divider: colors.primary.main,
      heading: colors.gray[450],
      text: colors.gray[450]
    },
    packages: {
      stepPackages: {
        heading: colors.gray[550],
        locationButtonBg: colors.blue[400],
        subtitle: colors.gray[300],
        divider: colors.blue[400],
        filterBg: colors.primary[200],
        filterTextColor: colors.secondary[500],
        item: {
          bgSelected: colors.gray[100],
          buttonBgSelected: colors.blue[300],
          buttonTextSelected: colors.white,
          buttonBg: colors.blue[400],
          buttonText: colors.white,
          iconSelected: colors.white,
          icon: colors.white,
          description: colors.black,
          subPackageDivider: colors.gray[300],
          dividerSelected: colors.gray[150],
          divider: colors.gray[125]
        },
        subPackages: {
          counterButtonBg: colors.blue[400],
          buttonInsideBg: colors.blue[400],
          buttonInsideBgHover: colors.blue[300],
          buttonBg: colors.blue[400],
          buttonBgHover: colors.blue[300],
          price: colors.black,
          priceMd: colors.secondary[500],
          discount: colors.red[700],
          priceStrikethrough: colors.black,
          priceStrikethroughLine: colors.black,
          discountText: colors.black,
          discountTextDesktop: colors.gray[275],
          tax: colors.black,
          description: colors.black,
          dividerInside: colors.gray[300],
          divider: colors.gray[125],
          showBtn: colors.gray[300]
        }
      },
      stepCartDetails: {
        heading: colors.gray[550],
        signInBg: colors.gray[100],
        signInText: colors.gray[300],
        signInButton: {
          border: colors.secondary.main
        },
        loaderBg: colors.blackOpacity[10],
        list: {
          divider: colors.blue[400],
          packageText: colors.gray[450],
          amountText: colors.gray[450],
          qtyText: colors.gray[450],
          totalText: colors.gray[450],
          taxText: colors.black,
          subtotalText: colors.black,
          innerDivider: colors.gray[200],
          item: {
            divider: colors.blue[200],
            text: colors.black,
            discount: colors.red[400],
            amountDivider: colors.secondary[500],
            amountLabel: colors.gray[450],
            amount: colors.black,
            totalLabel: colors.gray[450],
            total: colors.black
          }
        }
      },
      stepPayment: {
        heading: colors.gray[600],
        text: colors.gray[600],
        overlayBg: 'rgba(0, 0, 0, 0.8)',
        overlayTextColor: colors.white,
        divider: colors.primary.main
      },
      stepFinal: {
        heading: colors.gray[600],
        text: colors.gray[600],
        overlayBg: 'rgba(0, 0, 0, 0.8)',
        overlayTextColor: colors.white,
        divider: colors.primary.main
      },
      stepHighlighter: {
        activeLabelBg: colors.primary.main,
        activeLabelColor: colors.white,
        resetButton: colors.gray[300],
        divider: colors.gray[350],
        selectedLocationLabel: colors.gray[450],
        selectedLocationName: colors.black
      }
    },
    products: {
      listStep: {
        filterSidebar: {
          reviewStepActiveBg: colors.blue[400],
          reviewStepInactiveBg: colors.gray[115],
          reviewStepActiveText: colors.white,
          reviewStepInactiveText: colors.gray[600],
          activeBg: colors.blue[400],
          inactiveBg: colors.secondary[100],
          activeText: colors.white,
          inactiveText: colors.gray[800],
          itemBg: colors.white,
          emptyImageBg: colors.white,
          defaultIconColor: colors.blue[300],
          subTitleFilterBg: colors.gray[115],
          subTitleFilterColor: colors.gray[800],
          borderRight: colors.blue[400],
          collapseButtonBackground: colors.secondary[500],
          collapseButtonTextColor: colors.white,
          collapseButtonIconColor: colors.white
        },
        listContainer: {
          containerBg: colors.secondary[100],
          filterView: {
            breadcrumbText: colors.gray[800],
            iconActiveBg: colors.blue[400],
            iconActiveColor: colors.white,
            iconInactiveColor: colors.gray[200],
            textColor: colors.gray[800]
          },
          container: {
            activeIconColor: colors.blue[300],
            itemBg: colors.white,
            emptyImageBg: colors.white,
            defaultIconColor: colors.blue[300],
            productBg: colors.gray[50],
            itemNameColor: colors.gray[550],
            itemSubtitle: colors.gray[550],
            itemSizeColor: colors.gray[550],
            itemDescColor: colors.gray[550],
            itemCategoryColor: colors.gray[250],
            mainPriceColor: colors.gray[550],
            discountPrice: colors.gray[250],
            heartIconColor: colors.blue[300],
            counterBorder: colors.gray[550],
            closeButtonBackground: colors.white,
            closeButtonColor: colors.black,
            imageBackground: colors.white,
            zoomIconColor: colors.gray[300]
          }
        }
      }
    },
    giftCards: {
      title: colors.gray[600],
      description: colors.gray[600],
      divider: colors.blue[200],
      error: colors.red[500],
      progressBar: {
        background: colors.blue[400],
        completeColor: colors.blue[200],
        incompleteColor: colors.gray[250],
        activeColor: colors.white,
        activeTextColor: colors.white,
        inactiveTextColor: colors.gray[250]
      },
      list: {
        headerBg: colors.primary[100],
        headerColor: colors.gray[550],
        toggleButtonColor: colors.secondary[500],
        item: {
          boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.16)',
          selectedBorderColor: colors.black,
          unselectedBorderColor: 'transparent',
          buttonBg: colors.white,
          buttonActiveBg: colors.blue[300],
          buttonActiveBorderColor: colors.blue[300],
          buttonActiveColor: colors.white
        }
      },
      sidebar: {
        cardDetailsColor: colors.gray[600],
        cardBoxShadow: '0px 2px 3px rgba(0, 0, 0, 0.16)',
        amountLabelColor: colors.gray[300],
        amountValueColor: colors.gray[600],
        mobileBackground: colors.secondary[500],
        mobileTextColor: colors.white
      },
      stepSelectAmount: {
        title: colors.gray[600],
        promoBannerBg: colors.secondary[500],
        promoBannerText: colors.white,
        divider: colors.blue[200],
        subtitle: colors.gray[600],
        optionBg: colors.gray[100],
        optionSelectedBg: colors.secondary[500],
        optionText: colors.gray[600],
        optionSelectedText: colors.white,
        orEnterAmountText: colors.gray[600],
        inputBorder: colors.gray[260],
        inputBg: colors.gray[100],
        inputBgSelected: colors.secondary.main,
        inputText: colors.gray[600],
        inputTextSelected: colors.white,
        errorText: colors.red[500]
      },
      stepCreateAccount: {
        title: colors.gray[600],
        description: colors.gray[600],
        divider: colors.blue[200],
        emailBoxBg: colors.secondary[100],
        emailBoxColor: colors.gray[300]
      },
      stepDetails: {
        title: colors.gray[600],
        description: colors.gray[600],
        divider: colors.blue[200],
        checkboxBg: colors.primary[100],
        checkboxText: colors.gray[600],
        recipientFormTitle: colors.gray[600],
        errorText: colors.red[500],
        checkForm: {
          bg: colors.gray[100],
          bgSelected: colors.primary[250],
          svg: colors.gray[100],
          svgSelected: colors.primary[200],
          text: colors.gray[375],
          textSelected: colors.gray[800],
          email: colors.gray[375],
          saveEmail: colors.gray[375],
          selectFieldColor: colors.gray[300],
          selectFieldBorderColor: colors.primary[200],
          selectFieldBg: colors.primary[100]
        },
        recipient: {
          background: colors.primary[100],
          labelColor: colors.gray[375],
          fieldBackground: colors.white
        }
      },
      stepPaymentDetails: {
        headingColor: colors.blue[400],
        dividerColor: colors.blue[200]
      },
      stepCartDetails: {
        headingColor: colors.blue[400],
        dividerColor: colors.blue[200],
        errorMsgColor: colors.red[500],
        sampleModal: {
          overlayBg: 'rgba(0, 0, 0, 0.8)',
          boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.16)'
        },
        list: {
          headerTextColor: colors.gray[500],
          dividerColor: colors.blue[400],
          taxBorderColor: colors.gray[150],
          taxLabelColor: colors.black,
          taxValueColor: colors.black,
          subtotalBorderColor: colors.blue[200],
          subtotalLabelColor: colors.black,
          subtotalValueColor: colors.black,
          item: {
            borderColor: colors.blue[200],
            imageBoxShadow: '0px 2px 3px rgba(0, 0, 0, 0.16)',
            buttonTextColor: colors.gray[800],
            dividerColor: colors.blue[200],
            labelColor: colors.gray[300],
            textColor: colors.gray[600],
            amountTextColor: colors.black,
            totalTextColor: colors.black,
            popupBg: colors.whiteOpacity[80],
            popupTextColor: colors.gray[600],
            buttonBoxShadow: '0px 2px 3px rgba(0, 0, 0, 0.16)'
          }
        }
      },
      stepSuccess: {
        headingColor: colors.blue[400],
        subtitleColor: colors.gray[450],
        emailLinkColor: colors.gray[450],
        downloadTextColor: colors.gray[450],
        dividerColor: colors.blue[200]
      }
    },
    cart: {
      title: colors.gray[550],
      modal: {
        overlayBackground: 'rgba(0,0,0, 0.65)',
        dividerColor: colors.primary.main,
        titleColor: colors.gray[800],
        subTitleColor: colors.gray[400],
        descriptionColor: colors.gray[800],
        backBtnColor: colors.gray[300],
        loaderBg: 'rgba(0,0,0, 0.8)',
        loaderColor: colors.white
      },
      detailsStep: {
        divider: colors.blue[400],
        packageText: colors.gray[450],
        amountText: colors.gray[450],
        counterBorder: colors.gray[550],
        itemBg: colors.white,
        emptyImageBg: colors.white,
        defaultIconColor: colors.blue[300],
        qtyText: colors.gray[450],
        totalText: colors.gray[450],
        textColor: colors.black,
        amountDivider: colors.secondary[500],
        amountLabel: colors.gray[450],
        amount: colors.black,
        taxText: colors.black,
        subtotalText: colors.black,
        innerDivider: colors.gray[200],
        footerSmallText: colors.gray[250],
        discountPriceColor: colors.gray[375],
        promo: {
          bg: colors.gray[100],
          closeIcon: colors.gray[800],
          dollar: colors.gray[800],
          titleColor: colors.gray[800],
          code: colors.gray[800],
          sum: colors.red[700]
        }
      },
      shippingStep: {
        methodBg: colors.gray[100],
        textColor: colors.gray[800],
        bg: colors.white,
        activeBg: colors.gray[800],
        activeBorder: colors.gray[800],
        activeColor: colors.white,
        iconColor: colors.primary.main
      },
      accordion: {
        bg: colors.primary[200],
        sumColor: colors.black,
        itemBg: colors.gray[100],
        emptyImageBg: colors.white,
        defaultIconColor: colors.blue[300],
        textColor: colors.black,
        qtyColor: colors.gray[450],
        amount: colors.black,
        discountPriceColor: colors.gray[375]
      }
    },
    memberships: {
      heading: colors.gray[550],
      subtitle: colors.gray[300],
      divider: colors.blue[200],
      priceMd: colors.secondary[500],
      buttonBg: colors.blue[400],
      buttonBgHover: colors.blue[300],
      description: colors.black,
      dividerInside: colors.blue[200],
      showBtn: colors.gray[300],
      overlayBg: colors.secondaryOpacity[90],
      overlayTextColor: colors.white,
      signInBg: colors.gray[100],
      signInText: colors.gray[300],
      valuedMember: colors.gray[300],
      signInButton: {
        border: colors.blue[200]
      },
      reviewStepBackground: colors.gray[100],
      reviewStepTextColor: colors.gray[800],
      iconColor: colors.gray[800]
    }
  },

  booking: {
    stepService: {
      titleColor: colors.gray[550],
      descriptionColor: colors.gray[300],
      dividerColor: colors.primary.main,
      helperTextColor: colors.secondary[600],
      loaderBg: colors.blackOpacity[10],
      addonList: {
        headerBg: colors.blue[200],
        headerTextColor: colors.white
      },
      providerList: {
        headerBg: colors.secondary[500],
        providerItem: {
          bg: colors.gray[100],
          borderColor: colors.secondary[500],
          iconFill: colors.primary[300],
          descriptionColor: colors.gray[300]
        },
        providerHeader: {
          textColor: colors.white,
          closeIconFill: colors.white
        }
      },
      serviceList: {
        placeholderTextColor: colors.red[300],
        reviewTabBorderColor: colors.blue[400],
        defaultBorderColor: colors.secondary[500],
        infoModal: {
          overlayBackground: 'rgba(0, 0, 0, 0.3)',
          closeButtonBackground: colors.white,
          closeButtonColor: colors.black,
          bannerBorderColor: colors.gray[300],
          activeButtonBackground: colors.gray[300]
        },
        serviceItem: {
          background: colors.gray[100],
          checkedIconColor: colors.secondary[500],
          uncheckedBorderColor: colors.secondary[500],
          textColor: colors.secondary[500],
          iconColor: colors.secondary[500],
          hoverTextColor: colors.secondary[800],
          hoverIconColor: colors.secondary[800],
          iconFill: colors.primary[300],
          dividerColor: colors.gray[225]
        },
        serviceItemAccordion: {
          openBackground: colors.secondary[400],
          closedBackground: colors.gray[115],
          openTextColor: colors.white,
          closedTextColor: colors.secondary[500],
          openChevronColor: colors.white,
          closedChevronColor: colors.secondary[500],
          serviceBackground: colors.gray[100],
          dividerColor: colors.gray[350]
        }
      },
      mobileStepper: {
        reviewStepBackground: colors.gray[115],
        activeBackground: colors.secondary[500],
        inactiveBackground: colors.gray[100],
        activeTextColor: colors.white,
        inactiveTextColor: colors.gray[800],
        activeIconColor: colors.white,
        dividerColor: colors.secondary[500],
        collapseButtonBackground: colors.secondary[500],
        collapseButtonTextColor: colors.white,
        collapseButtonIconColor: colors.white
      },
      stepper: {
        reviewStepActiveBg: colors.blue[400],
        reviewStepInactiveBg: colors.gray[100],
        reviewStepActiveText: colors.white,
        reviewStepInactiveText: colors.gray[600],
        activeBg: colors.secondary[500],
        inactiveBg: colors.gray[100],
        activeText: colors.white,
        inactiveText: colors.gray[800]
      }
    },
    stepTime: {
      headingColor: colors.blue[400],
      descriptionColor: colors.gray[300],
      searchAgainButtonColor: colors.primary.main,
      subtitleColor: colors.gray[300],
      phoneLinkColor: colors.secondary.main,
      dividerColor: colors.primary.main,
      advancedSearch: {
        helperTextColor: colors.gray[600],
        daysLabelColor: colors.gray[375],
        dayActiveBg: colors.primary.main,
        dayInactiveBg: colors.white,
        dayTextColor: colors.gray[800],
        dayTextActiveColor: colors.white
      },
      apptData: {
        backgroundColor: colors.primary[100],
        dividerColor: colors.secondary.main,
        noOpeningsTextColor: colors.red[300],
        list: {
          titleBackgroundColor: colors.primary.main,
          titleTextColor: colors.white,
          item: {
            background: colors.white,
            hoverBorderColor: colors.primary.main,
            timeTextColor: colors.gray[800],
            endTimeTextColor: colors.gray[300],
            multipleProvidersBg: colors.gray[300],
            multipleProvidersIconColor: colors.white,
            providerNameTextColor: colors.gray[800],
            chevronIconColor: colors.gray[300]
          }
        }
      },
      apptDetailsList: {
        background: colors.primary[100],
        estimatedTotalLabelColor: colors.gray[300],
        estimatedTotalColor: colors.gray[800],
        detailsItem: {
          background: colors.white,
          serviceNameTextColor: colors.gray[800],
          providerIconColor: colors.primary[300],
          providerNameTextColor: colors.secondary[800],
          providerDescriptionTextColor: colors.secondary[800],
          itemPriceTextColor: colors.secondary.main,
          itemDurationTextColor: colors.gray[350],
          addonItem: {
            background: colors.white,
            addonNameTextColor: colors.gray[800],
            providerIconColor: colors.primary[300],
            providerNameTextColor: colors.secondary[800],
            providerDescriptionTextColor: colors.secondary[800],
            addonPriceTextColor: colors.secondary.main,
            addonDurationTextColor: colors.gray[350]
          }
        }
      },
      boxTabs: {
        tabBackground: colors.primary[200],
        tabTextColor: colors.gray[800],
        selectedTabBackground: colors.blue[400],
        selectedTabTextColor: colors.white,
        tabPanelBorderColor: colors.blue[400],
        tabPanelBackground: colors.primary[200]
      },
      calendarSearch: {
        buttonTextColor: colors.white
      }
    },
    stepRecommended: {
      headingColor: colors.blue[400],
      descriptionColor: colors.gray[300],
      dividerColor: colors.primary.main,
      list: {
        background: colors.gray[100],
        item: {
          itemBg: colors.white,
          emptyImageBg: colors.white,
          defaultIconColor: colors.blue[300],
          titleColor: colors.gray[800],
          subTitleColor: colors.black,
          descriptionColor: colors.secondary[800],
          priceColor: colors.gray[800],
          discountPriceColor: colors.gray[375]
        }
      }
    },
    stepReview: {
      headingColor: colors.blue[400],
      descriptionColor: colors.gray[300],
      dividerColor: colors.primary.main,
      mobileDividerColor: colors.gray[225],
      assistanceTextColor: colors.gray[300],
      phoneLinkColor: colors.secondary.main,
      errorTextColor: colors.red[500],
      requiredDdescription: {
        title: colors.red[600],
        subTitle: colors.gray[800],
        boxBg: colors.primary[100],
        description: colors.gray[800]
      },
      checkboxRules: {
        errorBackground: colors.redOpacity[5],
        errorBorder: colors.red[900],
        labelColor: colors.gray[800],
        textColor: colors.gray[800]
      },
      commentsBlock: {
        background: colors.primary[200],
        labelColor: colors.gray[800],
        textareaBackground: colors.white,
        focusBorderColor: colors.primary.main
      },
      promo: {
        background: colors.secondary[175],
        textColor: colors.gray[600],
        textLightColor: colors.gray[425],
        inputColor: colors.gray[800],
        placeholderColor: colors.gray[225]
      },
      reservationList: {
        background: colors.gray[100],
        textColor: colors.gray[800],
        iconColor: colors.gray[800],
        secondaerBackground: colors.primary[200],
        discountItem: {
          background: colors.gray[100],
          closeIconFill: colors.gray[350],
          discountTextColor: colors.gray[800],
          amountColor: colors.red[700]
        },
        reservationItem: {
          background: colors.gray[100],
          serviceNameColor: colors.gray[800],
          providerNameColor: colors.black,
          providerDescriptionColor: colors.secondary[800],
          iconFill: colors.primary[300],
          discountPriceColor: colors.secondary[500],
          priceColor: colors.gray[800],
          memberSaveColor: colors.gray[300],
          durationColor: colors.gray[350],
          dividerColor: colors.secondary[175]
        }
      }
    },
    stepSuccess: {
      headingColor: colors.blue[400],
      descriptionColor: colors.gray[300],
      dividerColor: colors.primary.main,
      headerDividerColor: colors.secondary[175],
      commentIconColor: colors.primary.main,
      commentTextColor: colors.gray[800],
      headerDetails: {
        headerBg: colors.secondary[500],
        headerText: colors.white,
        bodyBg: colors.secondary[175],
        location: colors.gray[800],
        address: colors.gray[800],
        iconColor: colors.primary.main,
        price: colors.gray[800],
        bookingText: colors.gray[800]
      },
      reviewList: {
        background: colors.gray[100],
        headerBackground: colors.blue[200],
        headerTextColor: colors.white,
        reviewItem: {
          serviceNameColor: colors.gray[800],
          providerNameColor: colors.black,
          providerDescriptionColor: colors.secondary[800],
          iconFill: colors.primary[300],
          discountColor: colors.secondary[500],
          priceColor: colors.gray[800],
          memberSaveColor: colors.gray[300],
          durationColor: colors.gray[350],
          dividerColor: colors.secondary[175]
        }
      },
      productList: {
        background: colors.gray[100],
        headerBackground: colors.blue[200],
        headerTextColor: colors.white,
        borderTopColor: colors.secondary[175],
        productItem: {
          itemBg: colors.white,
          emptyImageBg: colors.white,
          defaultIconColor: colors.blue[300],
          serviceNameColor: colors.gray[800],
          providerDescriptionColor: colors.black,
          discountColor: colors.secondary[500],
          priceColor: colors.blue[400],
          qtyColor: colors.gray[800],
          memberSaveColor: colors.gray[300],
          dividerColor: colors.blue[200]
        }
      }
    },
    loader: {
      textColor: colors.red[300]
    }
  },

  dashboard: {
    formsTable: {
      sectionHeaderBackground: colors.blue[200],
      pastFormsHeader: colors.white,
      requiredFormsHeader: colors.white,
      headerBackground: colors.primary[100],
      borderBottom: colors.blue[200],
      formLabel: colors.gray[400],
      contentBackground: colors.primary[100],
      formName: colors.secondary[800],
      dueDate: colors.secondary[800],
      chevronIcon: colors.blue[300]
    },
    recentProductList: {
      primaryBg: colors.primary[100],
      secondaryBg: colors.blue[200],
      headerText: colors.white,
      borderBottom: colors.blue[200],
      labelText: colors.gray[400],
      recentProductItem: {
        borderBottom: colors.blue[200],
        dateColor: colors.gray[550],
        nameColor: colors.gray[550],
        brandColor: colors.gray[300],
        priceColor: colors.gray[550],
        iconColor: colors.blue[300],
        chevronColor: colors.blue[300]
      }
    },
    dottedMenuButton: {
      borderBoxColor: colors.primary[200],
      background: colors.primary[200],
      cancelBorder: colors.primary[200],
      labelColor: colors.gray[800],
      iconColor: colors.blue[300]
    },
    upcomingAppts: {
      serviceTextColor: colors.gray[325],
      cancelButtonColor: colors.gray[800],
      chevronIconColor: colors.gray[800],
      bookButtonColor: colors.white,
      titleColor: colors.white,
      headerBg: colors.blue[200],
      wrapperBg: colors.primary[100],
      separatorColor: colors.blue[200]
    },

    account: {
      addresses: {
        headingColor: colors.blue[400],
        form: {
          background: colors.gray[100],
          checkboxLabelColor: colors.secondary.main
        },
        list: {
          contentLoaderBg: colors.primary[100],
          loaderBg: colors.blackOpacity[10],
          errorTextColor: colors.red[300],
          item: {
            bg: colors.gray[50],
            primaryBorderColor: colors.secondary.main,
            closeIconFill: colors.gray[250],
            primaryCloseIconFill: colors.gray[800],
            nameTextColor: colors.gray[800],
            addressTextColor: colors.gray[800],
            countryTextColor: colors.gray[800],
            primaryTextColor: colors.secondary.main,
            primaryBgColor: colors.secondary[200],
            chevronRightFill: colors.gray[800]
          }
        }
      },
      creditCards: {
        headingColor: colors.blue[400],
        textColor: colors.gray[600],
        list: {
          emptyBg: colors.primary[100],
          emptyTextColor: colors.gray[225],
          item: {
            background: colors.gray[50],
            borderColor: colors.secondary.main,
            activeBg: colors.primary.main,
            closeIcon: colors.gray[300],
            cardNumber: colors.gray[500],
            owner: colors.gray[800],
            primaryTextColor: colors.secondary.main,
            primaryBgColor: colors.secondary[200],
            divider: colors.secondary[500],
            defaultCardText: colors.gray[800],
            chevron: colors.gray[800]
          },
          purchaseItem: {
            bgColor: colors.primary[100],
            closeIconColor: colors.gray[300],
            cardNumberColor: colors.gray[500],
            ownerColor: colors.gray[800],
            purchaseTextColor: colors.gray[800],
            billingTextColor: colors.gray[800],
            chevronColor: colors.gray[800],
            greyColor: colors.gray[250],
            primaryColor: colors.primary.main
          }
        },
        updateForm: {
          bgColor: colors.gray[100],
          cardNumberColor: colors.gray[500],
          checkboxTextColor: colors.gray[800],
          dividerColor: colors.primary.main,
          borderColor: colors.primary.main,
          labelColor: colors.gray[375],
          textColor: colors.gray[800]
        }
      },
      preferences: {
        headingColor: colors.blue[400],
        textColor: colors.gray[600],
        itemTextColor: colors.gray[800],
        itemHeader: {
          headerBg: colors.primary[200],
          iconColor: colors.primary.main,
          titleColor: colors.gray[800],
          descriptionColor: colors.gray[800],
          contentBg: colors.primary[100]
        },
        variantCheckbox: {
          boxLabelColor: colors.primary.main,
          checkedBorderColor: colors.secondary.main,
          uncheckedBorderColor: colors.gray[350],
          dividerColor: colors.primary.main
        },
        variantDropdown: {
          labelColor: colors.primary.main,
          controlColor: colors.gray[600],
          borderBottomColor: colors.gray[350],
          optionColor: colors.gray[600],
          indicatorColor: colors.gray[600]
        },
        variantList: {
          labelColor: colors.primary.main,
          buttonColor: colors.gray[600],
          dividerColor: colors.primary.main
        }
      },
      profile: {
        reviewProfile: {
          backgroundColor: colors.primary[100],
          dividerColor: colors.blue[200],
          buttonTextColor: colors.blue[400],
          iconColor: colors.gray[800]
        },
        updatePassword: {
          backgroundColor: colors.primary[100]
        },
        updateProfile: {
          backgroundColor: colors.primary[100],
          iconBg: colors.primary[200]
        }
      }
    },

    memberships: {
      title: colors.gray[600],
      descriptionColor: colors.gray[300],
      headingColor: colors.blue[400],
      joinBtn: {
        bgColor: colors.secondary.main,
        labelColor: colors.white
      },
      joinCard: {
        background: colors.primary[100],
        heading: colors.gray[800]
      },
      mshpsList: {
        containerBg: colors.primary[100],
        headerBg: colors.blue[200],
        headerTextColor: colors.white,
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        noItemsTextColor: colors.gray[225],
        mshpsItem: {
          mainColor: colors.gray[550],
          subColor: colors.gray[300],
          dividerColor: colors.gray[125],
          chevron: colors.gray[800]
        }
      },
      mshpsDetails: {
        infoBg: colors.primary[100],
        infoBorder: colors.primary[200],
        infoBoxText: colors.gray[400],
        errorBg: colors.red[200],
        errorTextColor: colors.white,
        freezeBg: colors.blue.main,
        freezeTextColor: colors.white,
        detailsBg: colors.primary[100],
        subHeaderTextColor: colors.secondary[800],
        descColor: colors.gray[400],
        dividerColor: colors.gray[125],
        payBtnBg: colors.black,
        payBtnColor: colors.white,
        creditCard: {
          background: colors.primary[100],
          cardNumber: colors.gray[500],
          divider: colors.secondary[500],
          primaryBgColor: colors.secondary.main,
          primaryTextColor: colors.white
        }
      },
      modal: {
        overlayBackground: 'rgba(0,0,0, 0.65)',
        dividerColor: colors.primary.main,
        titleColor: colors.gray[800],
        subTitleColor: colors.gray[400],
        descriptionColor: colors.gray[800],
        backBtnColor: colors.gray[300],
        loaderBg: 'rgba(0,0,0, 0.8)',
        loaderColor: colors.white
      },
      payment: {
        boxBg: colors.primary[100],
        inputBorder: colors.gray[260],
        inputBg: colors.gray[100],
        inputBgSelected: colors.white,
        inputText: colors.gray[600],
        error: colors.red[300],
        overlayBg: colors.secondaryOpacity[90],
        overlayTextColor: colors.white
      }
    },
    referFriend: {
      title: colors.gray[600],
      infoBlock: {
        bg: colors.primary[100],
        title: colors.gray[600],
        text: colors.gray[600],
        subTitle: colors.gray[275],
        referalColor: colors.gray[600],
        iconColor: colors.gray[275]
      },
      detailsBlock: {
        headingBg: colors.primary[200],
        headingColor: colors.blue[400],
        bg: colors.primary[100],
        labelColor: colors.gray[600],
        bodyColor: colors.gray[400],
        borderInput: colors.gray[200]
      }
    },
    appointments: {
      title: colors.gray[600],
      apptList: {
        background: colors.primary[100],
        headerBackground: colors.blue[200],
        headerText: colors.white,
        emptyMessage: colors.gray[200],
        apptItem: {
          date: colors.gray[800],
          time: colors.gray[800],
          serviceName: colors.gray[800],
          providerName: colors.gray[325],
          divider: colors.blue[200],
          chevron: colors.blue[300]
        }
      },
      upcomingApptList: {
        background: colors.primary[100],
        headerBackground: colors.blue[200],
        headerText: colors.white,
        emptyMessage: colors.gray[200],
        upcomingApptItem: {
          date: colors.gray[800],
          time: colors.gray[800],
          serviceName: colors.gray[800],
          providerName: colors.gray[325],
          divider: colors.blue[200],
          chevron: colors.blue[300],
          moveButton: colors.secondary[800],
          cancelButton: colors.secondary[800]
        }
      },
      recent: {
        title: colors.gray[600],
        appointmentBg: colors.primary[250],
        appointmentDate: colors.gray[800],
        appointmentDetails: colors.gray[800],
        divider: colors.blue[200],
        totalAmount: colors.gray[800],
        receipt: colors.gray[800],
        receiptIcon: colors.gray[500],
        servicesBg: colors.primary[100],
        commentDivider: colors.primary.main,
        commentIcon: colors.primary.main,
        comments: colors.gray[800],
        buttonBg: colors.gray[800],
        overlayBg: colors.blackOpacity[10],
        headerBackground: colors.gray[275],
        contentBackground: colors.secondary[175],
        date: colors.white,
        buttonText: colors.white,
        location: colors.gray[800],
        iconLocationColor: colors.primary.main,
        address: colors.gray[800],
        amount: colors.gray[800],
        serviceBackground: colors.primary[100],
        repeatButtonBg: colors.secondary.main,
        receiptButtonText: colors.gray[800],
        receiptButtonBg: colors.primary[250],
        repeatMobileButtonText: colors.gray[800],
        repeatMobileButtonBg: colors.primary[250],
        serviceItem: {
          name: colors.gray[800],
          provider: colors.black,
          amountLabel: colors.gray[375],
          amount: colors.gray[800],
          duration: colors.gray[800],
          time: colors.gray[350],
          iconFill: colors.primary[300],
          divider: colors.gray[230]
        }
      },
      upcoming: {
        overlayBg: colors.blackOpacity[10],
        title: colors.gray[600],
        headerBackground: colors.secondary[500],
        contentBackground: colors.secondary[175],
        date: colors.white,
        divider: colors.whiteOpacity[17],
        buttonText: colors.white,
        location: colors.gray[800],
        iconLocationColor: colors.primary.main,
        address: colors.gray[800],
        amount: colors.gray[800],
        serviceBackground: colors.gray[50],
        commentDivider: colors.primary.main,
        commentIcon: colors.primary.main,
        commentText: colors.gray[800],
        repeatButtonBg: colors.secondary.main,
        moveButtonText: colors.gray[800],
        moveButtonBg: colors.secondary[175],
        cancelButtonText: colors.gray[800],
        cancelButtonBg: colors.secondary[175],
        serviceItem: {
          serviceName: colors.gray[800],
          providerName: colors.black,
          amountLabel: colors.gray[375],
          amountValue: colors.gray[800],
          duration: colors.gray[800],
          time: colors.gray[350],
          iconFill: colors.primary[300],
          divider: colors.gray[230]
        }
      }
    },

    forms: {
      formPage: {
        headerBg: colors.blue[200],
        headerText: colors.white,
        signature: {
          containerBg: colors.gray[100],
          instructionTextColor: colors.blue[200],
          penColor: colors.black,
          textColor: colors.black,
          background: colors.white
        }
      }
    },

    gCards: {
      containerBg: colors.gray[100],
      headingColor: colors.blue[400],
      formBg: colors.primary[100],
      formLabel: colors.gray[500],
      cardList: {
        containerBg: colors.primary[100],
        headerBg: colors.blue[200],
        headerTextColor: colors.white,
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        noItemsTextColor: colors.primary[250],
        iconFill: colors.primary[250],
        cardItem: {
          amountTextColor: colors.gray[800],
          dateTextColor: colors.gray[800],
          boxShadowColor: colors.blackOpacity[10],
          serialTextColor: colors.gray[800],
          amountLoadTextColor: colors.gray[800],
          dateLoadTextColor: colors.secondary[300],
          balanceTextColor: colors.gray[800],
          dividerColor: colors.gray[125],
          cardAccordion: {
            containerBg: colors.primary[200],
            balanceTextColor: colors.gray[350],
            balanceAmountColor: colors.black,
            dividerColor: colors.secondary[500],
            labelTextColor: colors.gray[350],
            valueTextColor: colors.gray[800]
          },
          cardAccordionBtn: {
            activeBg: colors.primary[200],
            activeIconFill: colors.white,
            iconFill: colors.primary.main
          }
        }
      }
    },

    orders: {
      headingColor: colors.blue[400],
      descriptionColor: colors.gray[400],
      ordersList: {
        containerBg: colors.primary[100],
        headerBg: colors.blue[200],
        headerTextColor: colors.white,
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        emptyMessageColor: colors.gray[225],
        item: {
          dateTextColor: colors.gray[800],
          checkoutIdTextColor: colors.gray[800],
          storeNameTextColor: colors.gray[800],
          storeNameTextMobileColor: colors.gray[500],
          itemsCountTextColor: colors.gray[800],
          itemsCountMobileTextColor: colors.gray[300],
          amountTextColor: colors.gray[800],
          iconColor: colors.gray[500],
          dividerColor: colors.gray[125]
        }
      },
      orderPage: {
        containerBg: colors.primary[100],
        borderColor: colors.primary.main,
        textColor: colors.gray[400],
        detailsList: {
          containerBg: colors.secondary[100],
          headerBg: colors.blue[200],
          headerTextColor: colors.white,
          borderBottomColor: colors.gray[125],
          emptyMessageColor: colors.gray[225],
          mobileDividerColor: colors.gray[300],
          detailsItem: {
            descriptionTextColor: colors.gray[800],
            priceTextColor: colors.gray[800],
            quantityTextColor: colors.gray[800],
            totalTextColor: colors.gray[800],
            itemBg: colors.primary[100],
            dividerColor: colors.gray[125],
            discountTextColor: colors.gray[300],
            discountAmountColor: colors.gray[300],
            promoTextColor: colors.gray[300],
            promoAmountColor: colors.gray[300],
            promoBg: colors.gray[115],
            promoIconColor: colors.gray[800]
          }
        }
      }
    },

    packages: {
      headingColor: colors.blue[400],
      packagesList: {
        containerBg: colors.primary[100],
        headerBg: colors.blue[200],
        headerTextColor: colors.white,
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        emptyMessageColor: colors.gray[225],
        packageItem: {
          nameTextColor: colors.secondary[800],
          unitsTextColor: colors.secondary[800],
          iconColor: colors.gray[800],
          dividerColor: colors.gray[125],
          expiresLabelColor: colors.gray[250],
          expiresTextColor: colors.secondary[800],
          amountLabelColor: colors.gray[250],
          amountTextColor: colors.secondary[800],
          buttonTextColor: colors.secondary[800],
          viewButtonTextColor: colors.secondary[800],
          receiptIconColor: colors.gray[400],
          mobileDividerColor: colors.gray[250]
        }
      },
      packagePage: {
        headingColor: colors.blue[400],
        packageBg: colors.blue[200],
        packageTextColor: colors.white,
        subPackageList: {
          containerBg: colors.primary[100],
          headerBg: colors.blue[200],
          headerTextColor: colors.white,
          emptyMessageColor: colors.gray[225],
          subPackageItem: {
            nameTextColor: colors.secondary[800],
            qtyLabelColor: colors.gray[250],
            qtyTextColor: colors.secondary[800],
            dividerColor: colors.secondary[500],
            usedLabelColor: colors.gray[250],
            usedTextColor: colors.secondary[800],
            remainingLabelColor: colors.gray[250],
            remainingTextColor: colors.secondary[800],
            mobileDividerColor: colors.gray[230]
          }
        }
      }
    },

    products: {
      headingColor: colors.blue[400],
      dividerColor: colors.primary.main,
      favoriteList: {
        containerBg: colors.primary[100],
        headerBg: colors.blue[200],
        headerTextColor: colors.white,
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        favoriteItem: {
          borderBottomColor: colors.gray[125],
          itemBg: colors.white,
          emptyImageBg: colors.white,
          defaultIconColor: colors.blue[300],
          noImageTextColor: colors.gray[300],
          heartIconColor: colors.blue[300],
          nameTextColor: colors.gray[550],
          brandTextColor: colors.gray[300],
          discountTextColor: colors.primary.main,
          priceTextColor: colors.gray[550],
          memberSaveTextColor: colors.gray[375],
          chevronIconColor: colors.blue[300],
          isMemberPrice: colors.primary.main,
          iconColor: colors.blue[300]
        }
      },
      recentList: {
        containerBg: colors.primary[100],
        headerBg: colors.blue[200],
        headerTextColor: colors.white,
        subHeaderTextColor: colors.gray[400],
        borderBottomColor: colors.gray[125],
        recentItem: {
          borderBottomColor: colors.gray[125],
          dateTextColor: colors.gray[550],
          providerTextColor: colors.gray[550],
          heartIconColor: colors.blue[300],
          nameTextColor: colors.gray[550],
          brandTextColor: colors.gray[300],
          priceTextColor: colors.gray[550],
          receiptIconColor: colors.blue[200],
          chevronIconColor: colors.blue[300],
          iconColor: colors.blue[300]
        }
      },
      browsePage: {
        headerBg: colors.secondary[500],
        selectControlTextColor: colors.gray[350],
        selectOptionTextColor: colors.gray[300],
        selectOptionBorderColor: colors.primary[200],
        selectOptionSvgColor: colors.secondary[500],
        dropdownIndicatorColor: colors.secondary[500],
        productsNumberTextColor: colors.white,
        productList: {
          containerBg: colors.primary[100],
          headerBg: colors.blue[200],
          headerTextColor: colors.white,
          productItem: {
            borderColor: colors.gray[125],
            imageBg: colors.white,
            noImageTextColor: colors.gray[300],
            favoriteIconColor: colors.blue[300],
            productNameColor: colors.gray[550],
            brandNameColor: colors.gray[300],
            discountColor: colors.secondary[500],
            priceColor: colors.blue[300],
            memberSaveColor: colors.gray[375],
            addToCartButtonTextColor: colors.gray[600],
            addToCartButtonBg: colors.white,
            iconColor: colors.blue[300]
          }
        }
      },
      productPage: {
        borderColor: colors.secondary.main,
        productBg: colors.primary[100],
        imageBg: colors.primary[200],
        noImageTextColor: colors.gray[300],
        productNameColor: colors.secondary.main,
        brandNameColor: colors.secondary.main,
        priceColor: colors.secondary[250],
        favoriteIconColor: colors.secondary[300],
        recentHistoryList: {
          containerBg: colors.primary[100],
          headerBg: colors.blue[200],
          headerTextColor: colors.white,
          labelTextColor: colors.gray[400],
          borderBottomColor: colors.gray[125],
          recentHistoryItem: {
            textColor: colors.gray[550],
            borderBottomColor: colors.gray[125],
            iconColor: colors.gray[500]
          }
        }
      }
    },

    service: {
      headingColor: colors.blue[400],
      serviceTable: {
        containerBg: colors.primary[100],
        headerBg: colors.blue[200],
        headerTextColor: colors.white,
        headerTextSecondaryColor: colors.gray[400],
        borderColor: colors.gray[125],
        textColor: colors.gray[550],
        iconColor: colors.blue[400],
        iconHoverColor: colors.blue[300]
      },
      serviceCards: {
        containerBg: colors.primary[100],
        headerBg: colors.blue[200],
        headerTextColor: colors.white,
        borderTopColor: colors.secondary[100],
        itemBorderColor: colors.gray[250],
        labelColor: colors.gray[250],
        iconColor: colors.gray[800],
        iconHoverColor: colors.gray[800]
      },
      servicePage: {
        headerBg: colors.blue[200],
        headerTextColor: colors.white,
        recentHistoryTable: {
          headerBg: colors.blue[200],
          headerTextColor: colors.white,
          containerBg: colors.primary[100],
          borderColor: colors.gray[125],
          headerTextSecondaryColor: colors.gray[400],
          textColor: colors.gray[550]
        },
        recentHistoryCards: {
          headerBg: colors.primary[200],
          containerBg: colors.primary[100],
          borderColor: colors.gray[125],
          labelColor: colors.gray[250],
          textColor: colors.gray[550]
        },
        recommendationTable: {
          headerBg: colors.blue[200],
          headerTextColor: colors.white,
          containerBg: colors.primary[100],
          borderColor: colors.gray[125],
          headerTextSecondaryColor: colors.secondary[800],
          textColor: colors.gray[550]
        }
      }
    }
  },

  components: {
    avatar: {
      badgeBgColor: colors.blue[300],
      badgeBorderColor: colors.primary.main,
      badgeTextColor: colors.white
    },
    contentLoader: {
      redVariantColor: colors.red[300],
      defaultColor: colors.gray[225]
    },
    footer: {
      bgColor: colors.secondary.main,
      textColor: colors.white,
      iconColor: colors.white,
      dividerColor: colors.secondary[250]
    },
    headerColor: {
      topBg: colors.white,
      bottomBg: colors.white,
      bottomBorder: colors.blue[200],
      iconColor: colors.blue[400],
      logoColor: 'transparent',
      primaryColor: colors.blue[300],
      linkColor: colors.blue[400],
      dividerColor: colors.blue[200],
      badgeBg: colors.blue[300],
      badgeColor: colors.white,
      tabletNavigation: {
        linkColor: colors.blue[300],
        bgColor: colors.white,
        buttonColor: colors.blue[300]
      }
    },
    cartBasket: {
      containerBg: colors.primary[100],
      itemBg: colors.white,
      textColor: colors.gray[800],
      borderColor: colors.gray[150],
      counterBorder: colors.gray[550],
      emptyImageBg: colors.white,
      defaultIconColor: colors.blue[300],
      errorButtonBg: colors.red[200],
      qtyBg: colors.gray[100]
    },
    locations: {
      heading: colors.gray[550],
      subtitle: colors.gray[300],
      icon: colors.primary.main,
      divider: colors.primary.main,
      bg: 'transparent',
      tileBg: colors.primary[200],
      tileColor: colors.gray[800],
      headingColor: colors.blue[400],
      headingBg: colors.gray[115],
      activeBg: colors.gray[100],
      favoriteIconColor: colors.blue[300],
      activefavoriteIconColor: colors.blue[300],
      itemBorder: colors.gray[125],
      locationName: colors.gray[800],
      phone: colors.gray[800],
      adress: colors.gray[800],
      mapIconColor: colors.blue[300],
      distance: colors.gray[500],
      locationPage: {
        headingColor: colors.blue[400],
        descriptionColor: colors.gray[300]
      },
      infoBanner: {
        bg: colors.gray[100],
        title: colors.gray[800],
        subTitle: colors.gray[800],
        iconColor: colors.blue[300]
      },
      dropdown: {
        bgColor: colors.primary[200],
        textColor: colors.gray[800],
        controlColor: colors.gray[800],
        controlBg: colors.white,
        indicatorColor: colors.gray[300]
      }
    },
    newCardForm: {
      bg: colors.gray[100],
      loaderBg: colors.blackOpacity[10],
      textColor: colors.gray[800],
      borderColor: colors.gray[200],
      secureMsg: colors.gray[275]
    },
    passwordRules: {
      checkIconColor: colors.blue[300],
      emptyIconBorderColor: colors.blue[300],
      textColor: colors.gray[800],
      reqBg: colors.secondary[200]
    },
    paymentList: {
      cardBg: colors.primary[100],
      buttonBg: colors.white,
      buttonActiveBg: colors.blue[300],
      buttonActiveBorderColor: colors.blue[300],
      buttonActiveColor: colors.white,
      cardNumberColor: colors.gray[500],
      cardOwnerColor: colors.gray[800],
      cardExpColor: colors.gray[800],
      cardExpErrorColor: colors.red[600],
      overlayBg: 'rgba(0, 0, 0, 0.8)',
      overlayTextColor: colors.white,
      divider: colors.primary.main,
      itemDivider: colors.gray[125],
      label: colors.gray[500],
      cardProcessingLoader: {
        boxBg: colors.gray[100],
        heading: colors.gray[800],
        iconFill: colors.gray[800],
        spinnerColor: colors.gray[800],
        helperText: colors.gray[800]
      }
    },
    giftCardList: {
      cardBg: colors.primary[100],
      buttonBg: colors.white,
      buttonActiveBg: colors.blue[300],
      buttonActiveBorderColor: colors.blue[300],
      buttonActiveColor: colors.white,
      boxShadowColor: colors.blackOpacity[10],
      cardNumberColor: colors.gray[500],
      appliedBg: colors.red[700],
      appliedColor: colors.white,
      errorModal: {
        bg: colors.gray[100],
        title: colors.gray[800],
        iconColor: colors.blue[300],
        serialColor: colors.gray[800],
        description: colors.gray[500]
      }
    },
    profileSidebar: {
      linkBg: colors.blue[300],
      linkColor: colors.white,
      activeLinkColor: colors.white,
      smallLinkActiveColor: colors.white,
      linkActiveBg: colors.blue[200],
      linkIconColor: colors.blue[300],
      linkAccordionItemIconColor: colors.blue[300],
      smallLinkBg: colors.blue[200],
      smallLinkActiveBg: colors.blue[200],
      accordionBg: colors.blue[300],
      accordionOpenBg: colors.blue[400],
      accordionOpenColor: colors.white,
      avatarBorderColor: colors.primary.main,
      avatarHoverBg: colors.whiteOpacity[80],
      iconFill: colors.gray[800],
      iconText: colors.gray[800],
      nickameColor: colors.gray[600],
      memberSinceTextColor: colors.gray[300],
      dividerColor: colors.blue[200],
      calendarIconFill: colors.primary.main,
      mobileBg: colors.blue[50],
      desktopBg: colors.blue[50],
      apptLabelColor: colors.gray[200],
      calendarTextColor: colors.white,
      calendarDateTextColor: colors.gray[600],
      apptLabelBg: colors.blue[300],
      calendarTextMobileColor: colors.white,
      calendarIconColor: colors.blue[300],
      calendarIconMobileColor: colors.secondary[300],
      signOutButtonColor: colors.gray[600],
      accountBalance: {
        titleBg: colors.red[600],
        titleColor: colors.white,
        amountBg: colors.red[100],
        amountColor: colors.gray[600]
      }
    },
    savingBlock: {
      bg: colors.primary[200],
      headerBg: colors.blue[200],
      headerTextColor: colors.white,
      amountColor: colors.secondary[500]
    },
    giftCardBlock: {
      bg: colors.primary[200],
      textHeaderColor: colors.gray[300],
      textContentColor: colors.secondary[500]
    },
    seeMore: {
      bg: colors.primary[200],
      textColor: colors.gray[800]
    },
    progress: {
      background: colors.blue[400],
      locationNameColor: colors.white,
      changeButtonColor: colors.white,
      stepIconActiveColor: colors.blue[200],
      stepIconInactiveColor: colors.gray[250],
      stepIconCurrentColor: colors.white,
      stepSeparatorCompleteColor: colors.primary.main,
      stepSeparatorIncompleteColor: colors.gray[250],
      stepTextSeenColor: colors.white,
      stepTextUnseenColor: colors.gray[250]
    },
    continueShoppingModal: {
      overlayBackground: 'rgba(0, 0, 0, 0.3)',
      dividerColor: colors.primary.main,
      titleColor: colors.black,
      descriptionColor: colors.gray[800],
      backBtnColor: colors.gray[300]
    },
    paymentErrorModal: {
      overlayBackground: 'rgba(255, 255, 255, 0.9)',
      titleColor: colors.gray[550],
      descriptionColor: colors.gray[550]
    },
    simpleErrorModal: {
      overlayBackground: 'rgba(255, 255, 255, 0.9)',
      titleColor: colors.gray[550],
      descriptionColor: colors.gray[550]
    },
    guestCheckoutModal: {
      overlayBackground: 'rgba(0, 0, 0, 0.3)',
      closeButtonBackground: colors.white,
      closeButtonColor: colors.black,
      bannerBorderColor: colors.gray[300],
      activeButtonBackground: colors.gray[300],
      borderColor: colors.primary[300]
    },

    ui: {
      counter: {
        counterSvgColor: colors.gray[230],
        counterTextColorBase: colors.black,
        counterTextColorLgDefault: colors.primary[300],
        counterTextColorLgAlt: colors.black
      },
      tabs: {
        tabBackground: colors.blue[200],
        tabSelectedAfterBg: colors.blue[300],
        tabColor: colors.white,
        bottomColor: 'transparent'
      },
      menu: {
        menuBackground: colors.blue[200],
        menuAvatarBorderColor: colors.blue[200],
        menuLabelColor: colors.white,
        menuIconColor: colors.blue[400],
        menuListBackground: colors.secondary[100],
        menuItemBackground: colors.secondary[100],
        menuItemActiveFontWeight: 600,
        menuDividerBorderColor: colors.blue[300],
        scrollColor: colors.blue[400]
      }
    }
  },
  theme: {
    generalStyles: {
      bodyTextColor: colors.gray[800],
      datePickerHeader: colors.primary[100],
      datePickerNavIcon: colors.primary.main,
      datePickerDayHoverBg: colors.primary[100],
      datePickerKeyboardSelectedBg: colors.primary[200],
      datePickerKeyboardSelectedHoverBg: colors.primary.main,
      datePickerSelectedDayBg: colors.primary[200],
      datePickerSelectedDayName: colors.gray[300],
      datePickerSelectedDayColor: colors.white,
      datePickerCurrentMonthColor: colors.gray[800],
      datePickerCurrentMonthBorderColor: colors.gray[150],
      datePickerNavArrowColor: colors.gray[800],
      datePickerDayColor: colors.gray[800],
      datePickerDayBg: 'transparent',
      datePickerSelectedDayBeforeBg: colors.primary.main,
      datePickerDayBeforeHoverBg: colors.primary[200]
    },
    button: {
      focusVisible: colors.primary[200],
      buttonSolidPrimaryColor: colors.white,
      buttonSolidPrimaryBg: colors.blue[300],
      buttonSolidSecondaryColor: colors.white,
      buttonSolidSecondaryBg: colors.secondary.main,
      buttonSolidSecondaryLightColor: colors.white,
      buttonSolidSecondaryLightBg: colors.blue[300],
      buttonSolidTextColor: colors.gray[600],
      buttonSolidTextBg: 'transparent',
      buttonSolidRedColor: colors.white,
      buttonSolidRedBg: colors.red[700],
      buttonSolidBlackColor: colors.white,
      buttonSolidBlackBg: colors.blue[400],
      buttonOutlinePrimaryBorderColor: colors.blue[400],
      buttonOutlinePrimaryColor: colors.blue[400],
      buttonOutlinePrimaryLightBorderColor: colors.blue[400],
      buttonOutlinePrimaryLightColor: colors.secondary.main,
      buttonOutlineSecondaryBorderColor: colors.blue[400],
      buttonOutlineSecondaryColor: colors.blue[400],
      buttonOutlineSecondaryLightBorderColor: colors.white,
      buttonOutlineSecondaryLightColor: colors.white,
      buttonOutlineBlackBorder: colors.blue[400],
      buttonOutlineBlackColor: colors.blue[400],
      buttonBrandPrimaryBg: colors.blue[400],
      buttonBrandPrimaryColor: colors.white,
      buttonBrandPrimarySvgFill: colors.white,
      buttonBrandPrimaryLightBg: colors.primary[300],
      buttonBrandPrimaryLightColor: colors.white,
      buttonBrandPrimaryLightSvgFill: colors.white,
      buttonBrandSecondaryBg: colors.white,
      buttonBrandSecondaryColor: colors.secondary.main,
      buttonBrandSecondarySvgFill: colors.white,
      buttonOutlineHoverPrimaryColor: colors.white,
      buttonOutlineHoverPrimaryBg: colors.blue[400],
      buttonOutlineHoverPrimaryLightBg: colors.blue[300],
      buttonOutlineHoverPrimaryLightColor: colors.white,
      buttonOutlineHoverSecondaryColor: colors.white,
      buttonOutlineHoverSecondaryBg: colors.blue[400],
      buttonOutlineHoverSecondaryLightColor: colors.white,
      buttonOutlineHoverSecondaryLightBg: colors.blue[400],
      buttonOutlineHoverBlackBg: colors.blue[400],
      buttonOutlineHoverBlackColor: colors.white,
      buttonBrandHoverPrimaryBg: colors.blue[400],
      buttonBrandHoverPrimaryColor: colors.white,
      buttonBrandHoverPrimarySvgFill: colors.white,
      buttonBrandHoverPrimaryLightBg: colors.blue[400],
      buttonBrandHoverPrimaryLightColor: colors.white,
      buttonBrandHoverPrimaryLightSvgFill: colors.white,
      buttonBrandHoverSecondaryBg: colors.blue[400],
      buttonBrandHoverSecondaryColor: colors.white,
      buttonBrandHoverSecondarySvgFill: colors.white,
      buttonTextColor: colors.white
    },
    checkbox: {
      checkboxPrimaryBorderColor: colors.blue[400],
      checkboxPrimaryCheckedBg: colors.blue[400],
      checkboxPrimaryCheckedBorderColor: colors.blue[400],
      checkboxPrimaryHoverBg: colors.blue[400],
      checkboxPrimaryHoverBorderColor: colors.blue[400],
      checkboxSecondaryBorderColor: colors.gray[300],
      checkboxSecondaryCheckedBg: colors.blue[300],
      checkboxSecondaryCheckedBorderColor: colors.blue[300],
      checkboxSecondaryHoverBg: colors.blue[200],
      checkboxSecondaryHoverBorderColor: colors.blue[200],
      checkboxGrayBorderColor: colors.gray[375],
      checkboxGrayCheckedBg: colors.gray[800],
      checkboxGrayCheckedBorderColor: colors.gray[800],
      checkboxGrayHoverBg: colors.gray[800],
      checkboxGrayHoverBorderColor: colors.gray[800],
      checkboxInvalidBorderColor: colors.red[900],
      checkboxOutlineColor: colors.gray[300]
    },
    input: {
      inputBrandFieldColor: colors.gray[800],
      inputBrandFieldBorderColor: 'transparent',
      inputBrandFieldBg: colors.white,
      inputBrandFieldHoverBorderColor: 'transparent',
      inputBrandFieldPlaceholderColor: colors.gray[600],
      inputBrandFieldFocusBorderColor: 'transparent',
      inputBrandFieldInvalidBorderColor: colors.red[500],
      inputBrandFieldInvalidBg: colors.redOpacity[5],
      inputAuthFieldBg: colors.primary[100],
      inputAuthFieldPlaceholderColor: colors.gray[600],
      inputAuthFieldInvalidBg: colors.redOpacity[5]
    },
    radio: {
      radioControlBorderColor: colors.blue[400],
      radioControlCheckedBg: colors.blue[400],
      radioControlCheckedBorderColor: colors.blue[400],
      radioControlCheckedBeforeBg: colors.blue[200],
      radioControlHoverBg: colors.blue[200],
      radioControlHoverBorderColor: colors.blue[200]
    },
    stepper: {
      stepperStepActiveBg: colors.blue[400],
      stepperTitleColor: colors.gray[600],
      stepperTitleActiveColor: colors.white,
      stepperPrimaryStepBg: colors.gray[50],
      stepperPrimaryStepActiveBg: colors.blue[400],
      stepperPrimaryTitleActiveColor: colors.white,
      stepperSecondaryStepBg: colors.gray[100],
      stepperSecondaryStepActiveBg: colors.secondary[500],
      stepperSecondaryTitleColor: colors.gray[800],
      stepperSecondaryTitleActiveColor: colors.white
    },
    tabs: {
      tabsRootBg: colors.primary.main
    }
  }
};

export default palette;
